import { AssumeRoleWithWebIdentityResponse } from '@aws-sdk/client-sts';
import { AwsClient } from 'aws4fetch';
import { jwtDecode } from 'jwt-decode';
import { REGION, REGION_CODE } from 'src/core/config/APIConstants';
import { getWebIdentityToken, fetchCredentials, isAFTXDomain } from 'src/utils/Auth';
import { getEnv, getRegion } from 'src/utils/Environment';


export const getJSONResponse = async ( response: Response | undefined ) =>
{
    const contentType = response?.headers.get( 'Content-Type' );
    if ( contentType !== 'application/json' )
    {
        throw new Error( 'Invalid content type' );
    }
    if ( response?.ok )
    {
        return response?.json();
    }
    else
    {
        const error = await response?.json();
        throw error;
    }
};

export class _apiGatewayClient
{
    public stsCredentialsExpiry: Date;
    public stsRole: AssumeRoleWithWebIdentityResponse | null;
    public client: AwsClient | null;
    public userAlias: string | null;

    constructor()
    {
        this.stsCredentialsExpiry = new Date();
        this.stsRole = null;
        this.client = null;
        this.userAlias = null;
        this.fetch = this.fetch.bind( this );
    }

    async fetchCredentials()
    {
        const midwayToken = await getWebIdentityToken();
        this.stsRole = await fetchCredentials( midwayToken );

        this.stsCredentialsExpiry = this.stsRole.Credentials?.Expiration ?? new Date();
    }

    createFetchClient()
    {
        const env = getEnv();
        const region: REGION = getRegion( location.host, env );

        this.client = new AwsClient( {
            region: REGION_CODE[ region ],
            accessKeyId: this.stsRole?.Credentials?.AccessKeyId ?? '',
            secretAccessKey: this.stsRole?.Credentials?.SecretAccessKey ?? '',
            sessionToken: this.stsRole?.Credentials?.SessionToken,
            service: 'execute-api',
        } );
    }

    async fetch( url: string, request?: RequestInit )
    {
        if ( isAFTXDomain() )
        {
            const response = await window.fetch( url, request );
            return getJSONResponse( response );
        }
        if ( this.stsCredentialsExpiry <= new Date() )
        {
            await this.fetchCredentials();
            this.createFetchClient();
        }

        const response = await this.client?.fetch( url, request );

        return getJSONResponse( response );
    }

}

export const apiGatewayClient = new _apiGatewayClient();

/**
 * Returns just the fetch client alone for other components to use
 */
export default apiGatewayClient.fetch;
